<template>
    <div>
       <skupovi-navigation
                :id="skup_id"
                :breadcrumbs="breadcrumbs"
        >
        </skupovi-navigation>
        <div class="ibox ">
            <div class="ibox-title">
                <h5>Tema: {{ naziv }}</h5>
            </div>
            <div class="ibox-content">
                <skup-tema-forma
                        :disabled="false"
                        :id="id"
                        :modal="false"
                        :action="'edit'"
                        @returnData="setData"
                >
                </skup-tema-forma>
            </div>
        </div>
    </div>
</template>

<script>
import SkupTemaForma from "@/views/pages/Skupovi/SkupoviTeme/SkupTemaForma";
import SkupoviNavigation from "@/views/pages/Skupovi/SkupoviNavigation";
export default {
  name: "SkupTemaEdit",
    components: {
        SkupTemaForma,
        SkupoviNavigation
    },
    data(){
        return {
            breadcrumbs: [],
            id:this.$route.params.tema_id,
            skup_id: this.$route.params.skup_id,
            skup: {},
            naziv: ''
        }
    },
    methods:{
        setBreadcrumbs() {
            this.breadcrumbs = [
                {
                    path: '/skupovi/' + this.skup_id + '/teme',
                    name: 'Teme'
                },
                {
                    path: '/skupovi/' + this.skup_id + '/teme/' + this.id,
                    name: 'Teme: ' + this.naziv
                },
                {
                    path: '/skupovi/' + this.skup_id + '/teme/' + this.id + '/edit',
                    name: 'Uredi temu: ' + this.naziv
                }
            ]
        },
        setData( data ){
            this.naziv = data.naziv
            this.setBreadcrumbs()
        },

    },
    mounted() {
    }
}
</script>

<style scoped>

</style>
